import { object } from 'zod/mini';
import type { infer as Infer } from 'zod/mini';
import {
    choiceField,
    columnField,
    repeated,
    switchField,
    textField,
    withDefaults,
} from '@h20-shared/dashboards';
import {
    FILTER_CONTROLS,
    FILTER_DEFAULT_FILTERS,
    FILTER_MAX_FILTERS,
} from './dashboard-filter.config';

const FILTER_SCHEMA = object({
    label: textField('Dashboard.FilterSettings.Label'),
    pluralLabel: textField('Dashboard.FilterSettings.PluralLabel'),
    column: columnField('Dashboard.FilterSettings.Column', (context) =>
        context.columns.map((column) => column.key)
    ),
    control: choiceField(FILTER_CONTROLS, 'Dashboard.FilterSettings.Control'),
    search: switchField('Dashboard.FilterSettings.Search', true),
    defaultLabel: textField('Dashboard.FilterSettings.DefaultLabel'),
    clearable: switchField('Dashboard.FilterSettings.Clearable', true),
});

export const FILTER_CONFIG_SCHEMA = withDefaults(
    object({
        filters: repeated(FILTER_SCHEMA, {
            max: FILTER_MAX_FILTERS,
            fallback: FILTER_DEFAULT_FILTERS,
            label: 'Dashboard.FilterSettings.Filters',
            itemLabel: 'Dashboard.FilterSettings.Filter',
            countLabel: 'Dashboard.FilterSettings.FilterCount',
        }),
        appliedSummary: switchField('Dashboard.FilterSettings.AppliedSummary', true),
        clearAll: switchField('Dashboard.FilterSettings.ClearAll', true),
    })
);

export type FilterConfig = Infer<typeof FILTER_SCHEMA>;
export type FilterWidgetConfig = Infer<typeof FILTER_CONFIG_SCHEMA>;
